var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8839 41.8661C38.3957 41.378 37.6043 41.378 37.1161 41.8661C36.628 42.3543 36.628 43.1457 37.1161 43.6339L38.8839 41.8661ZM61.75 66.5H63C63 66.1685 62.8683 65.8505 62.6339 65.6161L61.75 66.5ZM61.75 99.75V101C62.4404 101 63 100.44 63 99.75H61.75ZM38 99.75H36.75C36.75 100.44 37.3096 101 38 101V99.75ZM39.25 80.75C39.25 80.0596 38.6904 79.5 38 79.5C37.3096 79.5 36.75 80.0596 36.75 80.75H39.25ZM38 101C38.6904 101 39.25 100.44 39.25 99.75C39.25 99.0596 38.6904 98.5 38 98.5V101ZM14.25 99.75H13C13 100.44 13.5596 101 14.25 101V99.75ZM14.25 66.5L13.3661 65.6161C13.1317 65.8505 13 66.1685 13 66.5H14.25ZM38.8839 43.6339C39.372 43.1457 39.372 42.3543 38.8839 41.8661C38.3957 41.378 37.6043 41.378 37.1161 41.8661L38.8839 43.6339ZM41.5 47.5C41.5 48.1904 42.0596 48.75 42.75 48.75C43.4404 48.75 44 48.1904 44 47.5H41.5ZM99.75 99.75V101C100.44 101 101 100.44 101 99.75H99.75ZM61.75 98.5C61.0596 98.5 60.5 99.0596 60.5 99.75C60.5 100.44 61.0596 101 61.75 101V98.5ZM37.1161 43.6339L60.8661 67.3839L62.6339 65.6161L38.8839 41.8661L37.1161 43.6339ZM60.5 66.5V99.75H63V66.5H60.5ZM61.75 98.5H38V101H61.75V98.5ZM39.25 99.75V80.75H36.75V99.75H39.25ZM38 98.5H14.25V101H38V98.5ZM15.5 99.75V66.5H13V99.75H15.5ZM15.1339 67.3839L38.8839 43.6339L37.1161 41.8661L13.3661 65.6161L15.1339 67.3839ZM44 47.5V19H41.5V47.5H44ZM44 19C44 17.067 45.567 15.5 47.5 15.5V13C44.1863 13 41.5 15.6863 41.5 19H44ZM47.5 15.5H95V13H47.5V15.5ZM95 15.5C96.933 15.5 98.5 17.067 98.5 19H101C101 15.6863 98.3137 13 95 13V15.5ZM98.5 19V99.75H101V19H98.5ZM99.75 98.5H61.75V101H99.75V98.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.75 33.25V33.2975",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.75 33.25V33.2975",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.75 52.25V52.2975",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.75 71.25V71.2975",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.0516986fc2c72818e16518f99160b9a1.svg";
export { ForwardRef as ReactComponent };